// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"devicegroup_wrapper__dU1CQ","buttonContainer":"devicegroup_buttonContainer__uizQn"};